module.exports = __webpack_public_path__ + "static/img/bg-2.624408b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-2.jpg
// module id = Bbpe
// module chunks = 5